// FIXME: T235847
// eslint-disable-next-line local-rules/validate-freelancer-imports
import type { TotpMethod } from '@freelancer/datastore/collections/two-factor-details';
import type { AuthSuccessResponseAjax } from './login-signup.backend-model';

/**
 * Return value when 2FA is required, either from login or from sending 2FA
 */
export interface TwoFactorResponse {
  readonly message?: string;
  readonly preLoginToken: string;
  readonly method?: TotpMethod;
  readonly backoffTimeLeft?: number;
}

/**
 * Return value when an action is required for Oauth login
 */
export interface SSOActionResponse {
  readonly action: 'link' | 'signup';
  readonly ssoToken?: string;
}

export interface AuthReactivationResponse {
  readonly nextStep: 'account_reactivation';
  readonly userId: number;
}

export type AuthResponse =
  | TwoFactorResponse
  | AuthSuccessResponseAjax
  | SSOActionResponse
  | AuthReactivationResponse;

export enum LoginOrSignup {
  LOGIN = 'login',
  SIGNUP = 'signup',
}
